import { DimensionSettings } from '@fullstory/proto/fs/api/metrics';
import { TimeInterval, TimeRange } from '@fullstory/proto/fs/api/segment';
import { Card, UnnamedMetric } from '@fullstory/proto/fs/services/dx-objects';
import {
  Color,
  SegmentSettings,
  TimeRangeComparison,
} from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { MetricFormType } from './metricForm';
import { RollingWindow } from './rollingWindow';

export interface UnnamedMetricFormValues {
  metric: MetricFormType;
  segments: SegmentSettings[];
  timeRange: TimeRange | null;
  timeInterval: TimeInterval;
  dimensionSettings: DimensionSettings;
  metricId: string;
  unnamedMetric: UnnamedMetric | null;
  timeRangeComparison: TimeRangeComparison | null;
  singleNumberColor: Color;
  rollingWindow: RollingWindow;
}

export const metricCardTypes = [
  Card.settings.singleNumber,
  Card.settings.trend,
  Card.settings.dimensionality,
] as const;

export type MetricCardTypes = (typeof metricCardTypes)[number];
